import * as Yup from "yup";

export const maintenanceRequestValidationSchema = Yup.object({
  actionType: Yup.string().required("Action type is required"),

  reply: Yup.string()
    .required("Reply is required")
    .min(2, "Reply must be at least 2 characters"),

  // Start Date: required only if actionType === 'accepted'
  startDate: Yup.mixed().when("actionType", {
    is: "accepted",
    then: () =>
      Yup.date()
        .typeError("Start date must be a valid date")
        .required("Start date is required"),
    otherwise: () => Yup.date().nullable().notRequired(),
  }),

  // End Date: required only if actionType === 'accepted'
  // Also ensure endDate >= startDate only when startDate provided
  endDate: Yup.mixed().when(["actionType", "startDate"], {
    is: (actionType, startDate) => actionType === "accepted",
    then: (schema, context) => {
      // Note: context is not used here; we will build schema depending on startDate
      return Yup.date()
        .typeError("End date must be a valid date")
        .required("End date is required")
        .test(
          "end-after-start",
          "End date cannot be before start date",
          function (value) {
            const { startDate } = this.parent; // the startDate value from form
            if (!startDate || !value) return true; // if either missing, skip this test (other validators handle required)
            // compare as dates
            const s = new Date(startDate);
            const e = new Date(value);
            // normalize time portion by zeroing? depends on desired behavior — we allow same-day
            return e >= s;
          }
        );
    },
    otherwise: () => Yup.date().nullable().notRequired(),
  }),

  // Visit time: required only if actionType === 'accepted'
  visitTime: Yup.mixed().when("actionType", {
    is: "accepted",
    then: () =>
      Yup.string()
        .required("Visit time is required")
        .test(
          "is-time",
          "Visit time must be a valid time",
          (val) => {
            if (!val) return false;
            // basic HH:MM (24h) validation — adapt if you expect different format
            return /^[0-2]\d:[0-5]\d$/.test(val);
          }
        ),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),

  media: Yup.array().nullable(),
});
